import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const CertificateVerifyPage = () => {
  const [formData, setFormData] = useState({
    cnumber: '',
    ctype: ''
  });
  const [verificationResult, setVerificationResult] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Certificate Verification | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear previous results when user starts typing
    if (verificationResult) {
      setVerificationResult(null);
      setError('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.cnumber.trim()) {
      alert('Kindly fill all the fields first.');
      return;
    }
    
    if (!formData.ctype) {
      alert('Kindly select a type first.');
      return;
    }

    // Simulate verification - in real app this would call API
    // For demonstration, showing both success and failure cases
    const isValid = Math.random() > 0.5; // Random success/failure for demo
    
    if (isValid) {
      // Mock successful verification data
      if (formData.ctype === 'ply') {
        setVerificationResult({
          type: 'success',
          data: {
            certificate: formData.cnumber,
            player: 'John Doe',
            dob: '01-01-2000',
            father: 'James Doe',
            event_name: 'National Baseball Championship 2024'
          }
        });
      } else {
        setVerificationResult({
          type: 'success',
          data: {
            certificate: formData.cnumber,
            official: 'Jane Smith',
            dob: '15-05-1985',
            father: 'Robert Smith',
            event_name: 'National Baseball Championship 2024'
          }
        });
      }
    } else {
      setVerificationResult({
        type: 'error',
        message: 'This certificate is not Verified.'
      });
    }
  };

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/user-login">
          <div id="stick_right"></div>
        </Link>

        {/* Certificate Verification Content */}
        <div id="outer">
          <div id="icard_out" style={{paddingLeft: '10px', paddingRight: '10px'}}>
            <center><h3 className="hea3ding3">VERIFY CERTIFICATE</h3></center>
            <hr />
            <center>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input 
                    className="form-control" 
                    type="text" 
                    placeholder="Certificate Number" 
                    name="cnumber"
                    value={formData.cnumber}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div className="form-group">  
                  <select 
                    name="ctype" 
                    className="form-control"
                    value={formData.ctype}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>--Select Type--</option>
                    <option value="ply">Player</option>
                    <option value="offc">Official</option>
                  </select>
                </div>
                <hr />
                <input 
                  type="submit" 
                  className="btn btn-primary" 
                  value="VERIFY" 
                />
              </form>
            </center>
          </div>
        </div>

        {/* Verification Results */}
        {verificationResult && (
          <div className="container" style={{marginTop: '20px'}}>
            <div className="row">
              <div className="col-md-4 col-md-offset-4 text-center">
                {verificationResult.type === 'success' ? (
                  <div className="alert alert-success">
                    <strong>Success!</strong> This certificate is Verified.
                    <div className="list-group" style={{marginTop: '10px'}}>
                      <a href="#" className="list-group-item">
                        Certificate Number : {verificationResult.data.certificate}
                      </a>
                      <a href="#" className="list-group-item">
                        {formData.ctype === 'ply' ? 'Player' : 'Official'} Name : {verificationResult.data.player || verificationResult.data.official}
                      </a>
                      <a href="#" className="list-group-item">
                        Date Of Birth : {verificationResult.data.dob}
                      </a>
                      <a href="#" className="list-group-item">
                        Father Name : {verificationResult.data.father}
                      </a>
                      <a href="#" className="list-group-item">
                        Event Name : {verificationResult.data.event_name}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-danger">
                    <strong>Invalid!</strong> {verificationResult.message}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <PublicFooter />
    </div>
  );
};

export default CertificateVerifyPage;